module.exports = __webpack_public_path__ + "static/media/login-img.6455d9c2.png";